import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { COLORS_COOLGRAY20 } from '../../App.constants';

type IProps = BoxProps;
export const LoaderBox: React.FC<IProps> = (props) => {
  const { width = '70px', height = '21px', bgcolor = COLORS_COOLGRAY20, ...muiProps } = props;

  return (
    <Box
      {...muiProps}
      width={width}
      height={height}
      bgcolor={bgcolor}
    />
  );
};

LoaderBox.displayName = 'LoaderBox';
